var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCircleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3335 44C35.3792 44 44.3335 35.0457 44.3335 24C44.3335 12.9543 35.3792 4 24.3335 4C13.2878 4 4.3335 12.9543 4.3335 24C4.3335 35.0457 13.2878 44 24.3335 44Z",
    fill: "#36A0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9929 32C20.1843 32 19.4334 31.8169 18.7595 31.4508C17.2192 30.6086 16.3335 28.8877 16.3335 26.709V21.2899C16.3335 19.1296 17.2192 17.3904 18.7595 16.5482C20.2998 15.706 22.3022 15.8342 24.2854 16.9327L29.2336 19.6422C31.1975 20.7224 32.3335 22.3152 32.3335 23.9995C32.3335 25.6838 31.1975 27.2766 29.2336 28.3567L24.2854 31.0663C23.1686 31.6888 22.0327 32 20.9929 32ZM21.0122 18.7451C20.7041 18.7451 20.4346 18.8001 20.2228 18.9282C19.6067 19.2761 19.2408 20.1365 19.2408 21.2899V26.709C19.2408 27.8624 19.5874 28.7229 20.2228 29.0707C20.8389 29.4186 21.8016 29.2721 22.8606 28.6863L27.8088 25.9767C28.8678 25.3909 29.4647 24.6769 29.4647 23.9995C29.4647 23.3221 28.8678 22.5898 27.8088 22.0222L22.8606 19.3127C22.1674 18.9282 21.5321 18.7451 21.0122 18.7451Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.f59aa5f29304c2af2b5a5d49c3c2ed9a.svg";
export { ForwardRef as ReactComponent };